import { Link, Location, NavigateFunction } from "react-router-dom";
import { JSX, ReactNode } from "react";
import { w2d2dApiClient } from "./w2d2d-api-client.ts";

function buildLinkEl(from: Location, to: string, children: ReactNode): JSX.Element {
    return (
        <Link
            to={to}
            state={{ from: from }}
        >
            {children}
        </Link>
    )
}

function absoluteUrl(path: string): string {
    return `${w2d2dApiClient.appBaseUrl}${path.startsWith('/') ? path.substring(1) : path}`;
}

export const W2d2dNavigation = {
    ideas: {
        path: "/ideas",
        navigate: (navigate: NavigateFunction, from: Location): void => {
            navigate(W2d2dNavigation.ideas.path, {
                state: { from: from },
            })
        },

        add: {
            path: "/ideas/add",
            linkEl: (from: Location, children: ReactNode): JSX.Element => {
                return buildLinkEl(from, "/ideas/add", children)
            }
        },

        idea: (id: string) => {
            return {
                path: `/ideas/${id}`,
                absoluteUrl: absoluteUrl(`/ideas/${id}`),
                navigate: (navigate: NavigateFunction, from: Location, additionalState?: Record<string, unknown>): void => {
                    navigate(`/ideas/${id}`, {
                        state: { from: from, ...additionalState },
                    })
                },
                linkEl: (from: Location, children: ReactNode): JSX.Element => {
                    return buildLinkEl(from, `/ideas/${id}`, children)
                },

                edit: {
                    path: `/ideas/${id}/edit`,
                    absoluteUrl: absoluteUrl(`/ideas/${id}/edit`),
                    navigate: (navigate: NavigateFunction, from: Location): void => {
                        navigate(`/ideas/${id}/edit`, {
                            state: { from: from },
                        })
                    }
                },

                join: {
                    token: (token: string) => {
                        return {
                            path: `/ideas/${id}/join/${token}`,
                            absoluteUrl: absoluteUrl(`/ideas/${id}/join/${token}`),
                        }
                    }
                },

                announce: {
                    path: `/ideas/${id}/announce`,
                    navigate: (navigate: NavigateFunction, from: Location): void => {
                        navigate(`/ideas/${id}/announce`, {
                            state: { from: from },
                        })
                    }
                }
            }
        }
    },

    events: {
        path: "/events",

        event: (encodedUri: string) => {
            return {
                path: `/events/${encodedUri}`,
                absoluteUrl: absoluteUrl(`/events/${encodedUri}`),
                navigate: (navigate: NavigateFunction, from: Location, additionalState?: Record<string, unknown>): void => {
                    navigate(`/events/${encodedUri}`, {
                        state: { from: from, ...additionalState },
                    })
                },
                linkEl: (from: Location, children: ReactNode): JSX.Element => {
                    return buildLinkEl(from, `/events/${encodedUri}`, children)
                }
            }
        }
    },

    connections: {
        path: "/connections",
        navigate: (navigate: NavigateFunction, from: Location): void => {
            navigate(W2d2dNavigation.connections.path, {
                state: { from: from },
            })
        },
    },

    invitations: {

        invitation: (id: string) => {
            return {
                path: `/invitations/${id}`,
                navigate: (navigate: NavigateFunction, from: Location): void => {
                    navigate(`/invitations/${id}`, {
                        state: { from: from },
                    })
                }
            }
        }
    },

    settings: {
        path: "/settings",
        pods: {
            path: "/settings/pods",
            navigate: (navigate: NavigateFunction, from: Location): void => {
                navigate(W2d2dNavigation.settings.pods.path, {
                    state: { from: from },
                })
            },
        }
    }
}